import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import KuposModal from './KuposModal';
import SvgHome from './SvgHome';

export class PopupMessage extends Component {
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    console.log('Props in popup message are-----', this.props);
    return (
      <div className="common-popup-message">
        <KuposModal
          showModal={this.props.showModal}
          onHide={this.props.onHide}
          size="md"
          ariaLabel="login-modal"
        >
          <div className="login-signup-block delete-bip-card message-popup">
            <div
              className="close-button pointer"
              style={{ top: 8, right: 8 }}
              onClick={this.props.onHide}
            >
              <SvgHome name="close" />
            </div>

            <img src={this.props.metaData.kupos_popup_details[0].image_url} alt="popup-message" />
          </div>
        </KuposModal>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PopupMessage);



// WEBPACK FOOTER //
// ./src/features/common/PopupMessage.js